<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addGoodsTag">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        row-key="id"
        :data-source="table.data"
        style="width: 100%"
        :pagination="table.pagination"
        @change="handleTableChange"
        :loading = "table.loading"
        >
        <a-table-column
          data-index="name"
          title="标签名"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="country"
          title="地区"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="paramKey"
          title="货币单位"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="price"
          title="价格"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          title="操作">
          <template slot-scope="text, record">
            <a-button type="link" @click="editGoodsTag(record.id)">编辑
            </a-button>
            <a-button type="link" @click="deleteGoodsTag(record.id)">删除
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
          :footer="null"
             title="标签编辑"
             v-model="form.visible">
      <goods-tag-edit
        v-if="form.visible"
        :goods-tag-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goods-tag-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsTags,
  _queryGoodsTag,
  _deleteGoodsTag,
} from '@/api/goodsTagApi'
import GoodsTagEdit from './GoodsTagEdit.vue'

async function getGoodsTagList() {
  this.table.loading = true
  const result = await _queryGoodsTags({
    name: this.searchName,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: this.table.sort.order === 'ascend' ? 'ASC' : 'DESC',
  })
  if (result) { this.table.data = result.content }
  this.table.pagination.total = result.totalElements
  this.table.loading = false
}

function addGoodsTag() {
  this.form.data.id = null
  this.form.visible = true
}

function editGoodsTag(GoodsTagId) {
  this.form.data.id = GoodsTagId
  this.form.visible = true
}

function closeForm() {
  this.form.data.id = null
  this.form.visible = false
  this.getGoodsTagList()
}

async function deleteGoodsTag(GoodsTagId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsTag(GoodsTagId)
      this.$message.success('删除成功')
      await this.getGoodsTagList()
    },
  })
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current
  this.table.pagination.pageSize = pagination.pageSize
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    }
  }
  this.getGoodsTagList()
}

export default {
  name: 'GoodsTagList',
  components: { GoodsTagEdit },
  data() {
    return {
      searchName: '',
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    }
  },
  methods: {
    getGoodsTagList,
    deleteGoodsTag,
    editGoodsTag,
    addGoodsTag,
    closeForm,
    handleTableChange,
  },
  async created() {
    await this.getGoodsTagList()
  },
}
</script>

<style scoped>

</style>
